import ShareLoginInfo from './ShareLoginInfo';

export default ShareLoginInfo;
